import useJwt from '@/auth/jwt/useJwt';


export const getCustomerTotalOverView = async data => {
    const result = await useJwt.get(
      'dashboard?objectType=CustomerTotalOverView',
      {
        params: {
          search: {
            ...data,
          },
        },
      }
    );
    return result?.data.result;
  };
  

  export const getCustomerTotalQuotationByServ = async data => {
    const result = await useJwt.get(
      'dashboard?objectType=CustomerTotalQuotationByServ',
      {
        params: {
          search: {
            ...data,
          },
          pageSize: 5,
        },
      }
    );
    return result?.data.result;
  };
  export const getCustomerTotalBookingByServ = async data => {
    const result = await useJwt.get(
      'dashboard?objectType=CustomerTotalBookingByServ',
      {
        params: {
          search: {
            ...data,
          },
          pageSize: 5,
        },
      }
    );
    return result?.data.result;
  };
    export const getCustomerTotalRevenueByServ = async data => {
    const result = await useJwt.get(
      'dashboard?objectType=CustomerTotalRevenueByServ',
      {
        params: {
          search: {
            ...data,
          },
          pageSize: 5,
        },
      }
    );
    return result?.data.result;
  };

//   CustomerTotalQuotationByServ --> Quotation theo service của KH
// CustomerTotalBookingByServ -> Booking
// CustomerTotalRevenueByServ --> Revenue
